export function Footer() {
    return (
        <footer id='contact' className=" w-full">
            <div className="flex justify-center w-full p-5">
                <span className="text-sm text-white sm:text-center dark:text-gray-400">© Copyright 2023 PT Widea Izi Finansial
                </span>
            </div>
        </footer>
    );
}